// extracted by mini-css-extract-plugin
module.exports = {"loader":"_32bbee5fda--loader--xsHUI","spin":"_32bbee5fda--spin--EnEnc"};